import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { setSpecSurfaceFromPath } from "@/lib/analytics";
import { useIsMobile } from "@/hooks/use-mobile";
import { setSurface } from "@/lib/analytics";

/**
 * Sets analytics surface on route change.
 * Pageviews are handled natively by PostHog (capture_pageview: true).
 * Place once inside <BrowserRouter>.
 */
export function RouteAnalytics() {
  const { pathname } = useLocation();
  const prevPathRef = useRef<string | null>(null);
  const isMobile = useIsMobile();

  // 1) Set device surface (runs on mount + if breakpoint changes)
  useEffect(() => {
    setSurface(isMobile ? "mobile" : "desktop");
  }, [isMobile]);

  // 2) Set spec surface from route on navigation
  useEffect(() => {
    if (prevPathRef.current === pathname) return;
    prevPathRef.current = pathname;
    setSpecSurfaceFromPath(pathname);
  }, [pathname]);

  return null;
}
